export const FETCH_SCHEMES_PLAN_REQUEST = "FETCH_SCHEMES_PLAN_REQUEST";
export const FETCH_SCHEMES_PLAN_SUCCESS = "FETCH_SCHEMES_PLAN_SUCCESS";
export const FETCH_SCHEMES_PLAN_FAILURE = "FETCH_SCHEMES_PLAN_FAILURE";
